<template>
  <v-container>
    <v-row>
      <v-col class="py-4">
          <v-tabs
              v-model="pillsTab"
              centered
              color="basil"
              hide-slider
              active-class="tab-active"
          >
            <v-tab
                v-for="(i, index) in tabItems"
                :key="'pill' + index"
                :class="tabClass(index)"
                :data-test-id="`clientType${i.slag}`"
            >
              {{ i.name }}
            </v-tab>
          </v-tabs>
        <v-tabs-items v-model="pillsTab">
          <v-tab-item>
            <v-card>
              <v-card-text>
                <div class="identity__client">
                  <div class="form-inline d-block text-center">
                    <label class="my-1 mr-2" for="phone">Телефон:</label>
                    <!-- <the-mask id="phone" class="form-control m-2" placeholder="+7 (..." v-model="phone" type="tel" mask="+7(###)###-####"></the-mask> -->
                    <input  name="phone" class="form-control m-2" type="tel" data-test-id="discountPhone" placeholder="Телефон" v-model="phone" v-mask="'+7(###) ###-##-##'" />
                  </div>
                  <div class="form-inline d-block text-center">
                    <label class="my-1 mr-2" for="discountCard">или бонусная карта:</label>
                    <the-mask data-test-id="discountCard" id="discountCard" class="form-control m-2" placeholder="1000..." autofocus v-model="discountCard" type="text" mask="#######"></the-mask>
                  </div>
                  <div v-if="client.customer.phone != '' || client.customer.name != ''">
                    <p class="text-center">Клиент: <b data-test-id="clientInfo">{{ this.client.customer.name }} {{ this.client.customer.surname }}</b> Скидка: <b data-test-id="clientSale">{{ Math.trunc((this.client.discount.value + this.client.additional_discount.value) * 100) }}%</b></p>
                  </div>
                  <div v-if="clientErrorLocal">
                    <p class="text-center text-danger">{{ clientErrorLocal }}</p>
                  </div>
                  <template v-if="!client.customer.phone">
                    <div class="mb-2 text-center"><span class="font-italic font-size-20">Скидка от 10% постоянным клиентам</span></div>
                    <v-row>
                      <v-col class="d-flex justify-content-center">
                        <v-spacer />
                        <v-btn
                            class="v-btn font-italic"
                            :class="{
                              'active': clientErrorLocal
                            }"
                            tile
                            :to="{
                              path:'/newclient',
                              query: {
                                phone: phone
                              },
                            }"
                        >
                          Оформить бонусную карту
                        </v-btn>
                        <v-spacer />
                      </v-col>
                    </v-row>
                  </template>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <button
                    class="btn btn-danger mr-5"
                    data-test-id="continueWithOutDiscountButton"
                    v-bind:class="{ disabled: client.active == 1 }" @click.prevent="anonymousOrder()">Без скидки</button>
                <v-btn
                    to="/order/clientcard"
                    color="success"
                    data-test-id="continueWithDiscountButton"
                    :disabled="client.customer.phone == '' && client.customer.name == ''"
                >
                  Продолжить со скидкой
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card
                flat
                class="ml-auto mr-auto"
                width="800"
            >
              <v-card-text>
                    <v-autocomplete
                        data-test-id="companySelect"
                        v-model="chosenLegal"
                        :items="legalClients"
                        :menu-props="{ maxHeight: 450 }"
                        outlined
                        return-object
                        item-text="name"
                    >
                      <template v-slot:item="{ item }">
                        <div :data-test-id="`companyName-${item.name}`">
                          {{ item.name }}
                        </div>
                      </template>
                    </v-autocomplete>
<!--                    <select class="browser-default custom-select" name="select-company" v-model="chosenLegal">-->
<!--                      <option-->
<!--                          v-for="(legal, index) in legalClients"-->
<!--                          :value="legal"-->
<!--                          :key="'legal-' + index"-->
<!--                      >-->
<!--                        {{legal.name}}-->
<!--                      </option>-->
<!--                    </select>-->
                  </v-card-text>
              <v-card-actions>
                <v-spacer />
                <button
                        type="button"
                    class="btn btn-success"
                    @click="companyOrder"
                    data-test-id="continueWithCompany"
                    :class="{ disabled: !chosenLegal }"
                >
                  Продолжить
                </button>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card>
              <v-card-text>
                <div class="form-group">
                  <div class="identity__client">
                    <div class="form-inline d-block text-center">
                      <label class="my-1 mr-2" for="phone">Номер заказ-наряда:</label>
                      <input data-test-id="orderIdInput" name="order" class="form-control m-2" placeholder="Заказ-наряд" v-model="guaranteeOrderNumber" v-mask="'#######'"/>
                      <div class="text-danger small" role="alert" v-if="guaranteeOrderError">
                        <strong>Заказ-наряд не найден</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <button
                    data-test-id="guaranteeNext"
                    class="btn btn-success"
                    :class="{ disabled: !guaranteeOrderNumber }"
                    @click.prevent="getGuaranteeOrder(guaranteeOrderNumber)"
                >
                  Продолжить
                </button>
                <v-spacer />
              </v-card-actions>
            </v-card>
              <div>
                <modal name="guaranteeModal" :adaptive="true" height="auto" :scrollable="true" :clickToClose="false">
                  <div class="row justify-content-center p-4">
                    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                      <h5 class="h5">Услуги в заказ-наряде {{ guaranteeOrder.id }} от {{ formattingTime(guaranteeOrder.created_at) }}</h5>
                    </div>
                    <table class="table table-hover">
                      <thead class="thead-light">
                      <tr>
                        <th scope="col">Наименование</th>
                        <th scope="col">Кол-во</th>
                        <th scope="col">Цена</th>
                        <th scope="col">Сумма</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr
                          v-for="(service, index) in guaranteeOrder.services"
                          :key="'service-' + index"
                      >
                        <td>{{ service.title }}</td>
                        <td>{{ service.pivot.quantity }}</td>
                        <td>{{ service.pivot.price }} ₽</td>
                        <td>{{ service.pivot.quantity * service.pivot.price }} ₽</td>
                      </tr>
                      </tbody>
                    </table>
                    <div class="d-flex justify-content-between">
                      <button class="btn btn-outline-success" @click.prevent="resetGuaranteeOrder()">Отмена</button>
                      <button data-test-id="guaranteeInWork" :disabled="stateInProgress" class="btn btn-success" @click.prevent="takeGuaranteeOrder(guaranteeOrderNumber, shiftData.id)">Далее</button>
                    </div>
                  </div>
                </modal>
                <modal name="guaranteeCreatedModal" :adaptive='true' height="auto" :scrollable='true' :clickToClose='false'>
                  <div class="row justify-content-center p-4">
                    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                      <h5 class="h5">Создана гарантия #{{ guaranteeCreated }} по заказ-наряду #{{ guaranteeOrder.id }} от {{ formattingTime(guaranteeOrder.created_at) }}</h5>
                      <button data-test-id="guaranteeIsEnd" class="btn btn-success" @click.prevent="hideGuaranteeCreatedModal()">Нажмите после выполнения работ</button>
                    </div>
                  </div>
                </modal>
<!--                <sms-confirm-->
<!--                  ref="dlg"-->
<!--                  :order-id="guaranteeOrderNumber"-->
<!--                  code-type="guarantee"-->
<!--                  style="z-index: 1001"-->
<!--                />-->
              </div>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex'
// import smsConfirm from './smsComfirm.vue'
export default {
  name: "ClientIdentify",
  components: {
    // smsConfirm,
  },
  data() {
    return {
      stateInProgress: false,
      pillsTab: 0,
      tabItems: [
        {
          name: 'Клиент',
          slag: 'Client'
        },{
          name: 'Компания',
          slag: 'Company'
        },{
          name: 'Гарантия',
          slag: 'Guarantee'
        },
      ],
      phone: '',
      discountCard: '',
      guaranteeOrderNumber: '',
      clientErrorLocal: '',
    }
  },
  created() {
    this.$store.commit('resetClient')
    this.$store.commit('resetCarData')
    this.$store.commit('setCanEditClientCard', false)
  },
  async mounted() {
    this.$store.dispatch("login/getWorkshop");
    this.$store.dispatch("fetchLegalClients");
  },
  computed: {
    chosenLegal: {
      get () {
        return this.$store.getters.chosenLegal
      },
      set (value) {
        console.log('cl ', value)
        this.$store.commit('updateChosenLegal', value)
      }
    },
    ...mapGetters([
      "client",
      "clientError",
      "legalClients",
      "step",
      "guaranteeOrder",
      "guaranteeOrderLoaded",
      "guaranteeOrderError",
      "guaranteeCreated",
    ]),
    ...mapGetters('shift', [
      "shiftData"
    ]),
  },
  watch: {
    phone() {
      while(this.phone.charAt(0) === '8' || this.phone.charAt(0) === '7')
      {
        return this.phone = this.phone.substr(1);
      }
      if(this.phone.length == 17) {
        this.getClient(this.phone.replace(/[^0-9.]/g, '').substr(1), 'phone')
      }
      if(this.phone.length < 17) {
        this.$store.commit('resetClient')
        this.clientErrorLocal = ''
      }
    },
    discountCard() {
      if(this.discountCard.length == 7) {
        this.getClient(this.discountCard, 'discountCard')
        // this.$store.commit('nextStep', 2)
      }
    },
    client: {
      handler(){
        if(this.client.discount.card_number) {
          this.discountCard = this.client.discount.card_number
        }
      },
      deep: true
    },
    guaranteeOrderLoaded() {
      if(this.guaranteeOrderLoaded) {
        this.showGuaranteeModal()
      }
    },
    guaranteeCreated() {
      if(this.guaranteeCreated) {
        this.showGuaranteeCreatedModal()
      }
    }
  },
  methods: {
    formattingTime(time) {
      if (!time) return ''
      console.log(time)
      const timeWithOutTrash = time.split('.')[0]
      const [year, month, day] = timeWithOutTrash.split('T')[0].split('-')
      console.log(timeWithOutTrash.split('T')[0].split('-'))
      const timeSplit = timeWithOutTrash.split('T')[1].slice(0,5)
      return `${day}.${month}.${year} ${timeSplit}`
    },
    tabClass(index) {
      return 'tab-class-' + index
    },
    getClient(searchString, type) {
      this.$store.commit('resetClient')
      this.$store.commit('resetChoosenServicesComponent')
      this.$store.dispatch('fetchClient', {searchString, type}).catch(error =>{
        const response = JSON.parse(error.request.response) ;
        const textError = response.message;
        const textRefactor = textError.replace(' (101)', '');

        this.clientErrorLocal = textRefactor
      })
    },
    companyOrder() {
      this.$store.commit('resetChoosenServicesComponent')
      this.$router.push('/order/clientcard')
    },
    anonymousOrder() {
      this.$store.commit('resetClient')
      this.$store.commit('resetChoosenServicesComponent')
      this.$store.commit('anonymousClient')
      this.$router.push('/order/clientcard')
    },
    getGuaranteeOrder(order_id) {
      this.$store.dispatch('fetchGuaranteeOrder', { order_id })
    },
    takeGuaranteeOrder(order_id, shift_id) {
      // this.stateInProgress = true
      // this.$store.dispatch('getSubmitSmsCode', {order_id: order_id}).then(() => {
      //   this.$refs.dlg.open({
      //     acceptText: 'Продолжить',
      //     cancelText: 'Отмена',
      //     dialogMaxWidth: 600,
      //   }).then(() => {
      this.$store.dispatch('createGuaranteeOrder', { order_id, shift_id}).catch((e) => {
          this.stateInProgress = false
          console.log('Error', e)
        })
      // }).catch((e) => {
      //   this.stateInProgress = false
      //   console.log('Error', e)
      // })
    },
    showGuaranteeModal() {
      this.$modal.show('guaranteeModal')
    },
    hideGuaranteeModal() {
      this.$modal.hide('guaranteeModal')
    },
    showGuaranteeCreatedModal() {
      this.$modal.hide('guaranteeModal')
      this.$modal.show('guaranteeCreatedModal')
    },
    hideGuaranteeCreatedModal() {
      this.resetGuaranteeOrder()
      this.$modal.hide('guaranteeCreatedModal')
      this.$router.push('/')
    },
    resetGuaranteeOrder() {
      this.$store.commit('setGuaranteeOrderLoaded', false)
      this.$store.commit('updateGuaranteeOrder', {})
      this.$store.commit('updateGuaranteeOrderError', false)
      this.$store.commit('updateGuaranteeCreated', false)
      this.guaranteeOrderNumber = ''
      this.hideGuaranteeModal()
    }
  }
}
</script>
<style scoped>
  .v-btn.active {
    box-shadow: 0px 0px 10px 5px #00c851;
  }
.tab-class-0 {
  margin: 0 5px;
  color: #1976d2;
  background-color: #00c851;
}
.tab-class-1 {
  margin: 0 5px;
  color: #1976d2;
  background-color: #00c851;
}
.tab-class-2 {
  margin: 0 5px;
  background-color: transparent !important;
  border-color: #00c851 !important;
  -webkit-box-shadow: 0 5px 11px 0 rgba(0,0,0,0.18),0 4px 15px 0 rgba(0,0,0,0.15);
  box-shadow: 0 5px 11px 0 rgba(0,0,0,0.18),0 4px 15px 0 rgba(0,0,0,0.15);
  color: #fff;
  border: 2px solid #1c7430;
}
.tab-active {
  color: #fff !important;
  background-color: #006228 !important;
  -webkit-box-shadow: 0 5px 11px 0 rgba(0,0,0,0.18),0 4px 15px 0 rgba(0,0,0,0.15);
  box-shadow: 0 5px 11px 0 rgba(0,0,0,0.18),0 4px 15px 0 rgba(0,0,0,0.15);
}
.clientidentify__tab {
  margin: 0 5px;
  color: #fff !important;
  background-color: #00c851;
}
.clientidentify__tab--active {
  background-color: #006228;
}
.bg-barcode {
  /* The image used */
  background-image: url("/images/barcode.png");

  /* Control the height of the image */
  min-height: 280px;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  position: relative;
}

.blink {
  animation: blinker 1s ease-out 1;
  animation-fill-mode: forwards;
}

@keyframes blinker {
  to { background-color: #00c851;
    color: white; }
}
</style>
